"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const yup = __importStar(require("yup"));
const TIME_REGEX = /(((1?[0-2])|(0[1-9])):([0-5][0-9]))/;
const DATE_REGEX = /\d\d\/\d\d\/\d\d\d\d/;
const DATETIME_REGEX = /\d\d\/\d\d\/\d\d\d\d \d\d:\d\d [AP][M]/;
const EMAIL_REGEX = /\d\d\/\d\d\/\d\d\d\d/;
const TEL_REGEX = /\d\d\/\d\d\/\d\d\d\d/;
const Validator = {
    _schemas: undefined,
    schemas: () => {
        if (!Validator._schemas)
            Validator._schemas = {
                title: yup.string().trim().required(lib_i18n_1.default.t('error-invalid-required')),
                // .min(3, i18n.t('error-invalid-length-min-max', { min: 3, max: 100 }))
                // .max(100, i18n.t('error-invalid-length-min-max', { min: 3, max: 100 })),
                description: yup.string(),
                time: yup
                    .string()
                    .required(lib_i18n_1.default.t('error-invalid-required'))
                    .matches(TIME_REGEX, lib_i18n_1.default.t('error-invalid-time')),
                date: yup
                    .string()
                    .required(lib_i18n_1.default.t('error-invalid-required'))
                    .matches(DATE_REGEX, lib_i18n_1.default.t('error-invalid-date'))
                    .test('valid-datetime', lib_i18n_1.default.t('error-invalid-date'), v => v && (0, moment_timezone_1.default)(v, 'DD-MM-YYYY').isValid()),
                dateTime: yup
                    .string()
                    .required(lib_i18n_1.default.t('error-invalid-required'))
                    .matches(DATETIME_REGEX, lib_i18n_1.default.t('error-invalid-datetime'))
                    .test('valid-datetime', lib_i18n_1.default.t('error-invalid-datetime'), v => v && (0, moment_timezone_1.default)(v, 'DD-MM-YYYY hh:mm a').isValid()),
                email: yup
                    .string()
                    .required(lib_i18n_1.default.t('error-invalid-required'))
                    .email(lib_i18n_1.default.t('error-invalid-email')),
                validEmail: yup.string().email(lib_i18n_1.default.t('error-invalid-email')),
                createdBy: yup.object().shape({
                    id: yup.string().required(lib_i18n_1.default.t('error-invalid-required')),
                }),
                flag: yup.string().required(lib_i18n_1.default.t('error-invalid-required')),
                type: yup.string().required(lib_i18n_1.default.t('error-invalid-required')),
                place: yup.object().shape({
                    id: yup.string().required(lib_i18n_1.default.t('error-invalid-required')),
                }),
            };
        return Validator._schemas;
    },
    validate(obj) {
        const s = this.schemas();
        Object.keys(obj).every(k => {
            if (s[k]) {
                s[k].validateSync(obj[k]);
            }
        });
    },
    isValid(obj) {
        const s = this.schemas();
        return Object.keys(obj).every(k => {
            if (s[k]) {
                return s[k].isValidSync(obj[k]);
            }
            return true;
        });
    },
};
exports.default = Validator;
